<div class="row">
  <div class="col">
    <header class="bg-brand-header fixed-top">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <nav class="navbar navbar-expand-lg navbar-light">
              <button
                (click)="toggleNavBar()"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                class="navbar-toggler p-0"
                data-target="#navbarSupportedContent"
                data-toggle="collapse"
                type="button"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="d-flex">
                <a
                  *ngIf="!!(logoUrl$ | async)"
                  [href]="logoAnchorUrl$ | async"
                  aria-hidden="true"
                  class="navbar-brand mr-0 no-logo"
                  id="mcBrandLogo"
                  ><img
                    [attr.height]="logoHeight$ | async"
                    [attr.width]="logoWidth$ | async"
                    [src]="logoUrl$ | async"
                    alt=""
                    class="header-logo"
                /></a>
                <a [href]="logoAnchorUrl$ | async" class="navbar-brand mr-0" id="brandLogo"> </a>
                <a
                  [innerHTML]="siteName$ | async"
                  [style]="siteNameStyle$ | async"
                  class="navbar-brand no-logo"
                  routerLink="/home"
                  id="brandName"
                >
                </a>
              </div>

              <div [ngbCollapse]="isNavBarCollapsed" class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul *ngIf="!isSigningOut" class="navbar-nav me-auto">
                  <li class="nav-item divider-vertical d-none d-lg-block"></li>
                  <ng-container>
                    <li class="nav-item dropdown">
                      <a
                        class="nav-link dropdown-toggle"
                        href=""
                        (click)="(false)"
                        id="myProductsLinksMenu"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        >My Products</a
                      >
                      <div class="dropdown-menu" aria-labelledby="myProductsLinksMenu">
                        <a
                          class="dropdown-item"
                          routerLink="/products"
                          id="myDataProducts"
                          *appIfFeature="'!data_entitlement_v2'"
                          >My Data Products</a
                        >
                        <a
                          class="dropdown-item"
                          routerLink="/data"
                          id="dataProducts"
                          *appIfFeature="'data_entitlement_v2'"
                          >My Data Products</a
                        >
                        <a class="dropdown-item" routerLink="/software" id="mySoftwareProducts">My Software Products</a>
                      </div>
                    </li>
                  </ng-container>
                  <!--              <li *appHasPermission="'myClients'" class="nav-item">-->
                  <!--                <a class="nav-link" routerLink="/clients">My Clients</a>-->
                  <!--              </li>-->
                  <li class="nav-item">
                    <a class="nav-link" routerLink="/samples" id="samples">Sample Datasets</a>
                  </li>

                  <li class="nav-item dropdown">
                    <a
                      (click)="(false)"
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      href="#"
                      id="navbarDropdownMenuLink"
                      role="button"
                      >Visualize</a
                    >
                    <div aria-labelledby="navbarDropdownMenuLink" class="dropdown-menu">
                      <a class="dropdown-item" routerLink="/visualization/map-explorer">Map Explorer</a>
                      <a class="dropdown-item" routerLink="/usecases/property-risk" *appIfFeature="'!hide_demo_sites'"
                        >Property Risk Profile Demo</a
                      >
                      <a
                        class="dropdown-item"
                        routerLink="/usecases/home-search-real-estate"
                        *appIfFeature="'!hide_demo_sites'"
                        >Home Search Real Estate Demo</a
                      >
                    </div>
                  </li>
                </ul>

                <ul *ngIf="isSigningOut" class="navbar-nav me-auto"></ul>

                <ul class="navbar-nav navbar-right">
                  <li *ngIf="!isSigningOut" class="nav-item">
                    <button aria-label="Search" class="btn btn-icon-only text-white" routerLink="/search">
                      <i aria-hidden="true" class="pbi-icon-outline pbi-search d-lg-inline" id="searchHeader"></i>
                    </button>
                  </li>

                  <li class="nav-item dropdown" *ngIf="!(isMasterCardUser$ | async)">
                    <button
                      class="btn btn-icon-only dropdown-toggle text-white"
                      id="communityDropDown"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      type="button"
                    >
                      <i class="pbi-icon-outline pbi-apps d-none d-lg-inline" aria-hidden="true"></i>
                      <span class="d-lg-none" id="app-offscreen">
                        <i class="pbi-icon-mini pbi-grid-4" aria-hidden="true"></i>&nbsp;Applications
                      </span>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="communityDropDown">
                      <div class="section-head hidden-xs">Your Apps</div>
                      <a class="dropdown-item" href="https://customer.precisely.com/" target="_blank"
                        >Customer Community</a
                      >
                      <a class="dropdown-item" href="https://partner.precisely.com/" target="_blank"
                        >Partner Community</a
                      >
                    </div>
                  </li>

                  <!-- Support menu -->
                  <li *ngIf="!isSigningOut" class="nav-item dropdown menu-help">
                    <button
                      aria-expanded="false"
                      aria-haspopup="true"
                      aria-labelledby="help-offscreen"
                      class="btn btn-icon-only dropdown-toggle text-white"
                      data-bs-toggle="dropdown"
                      id="help"
                    >
                      <i aria-hidden="true" class="pbi-icon-outline pbi-help-circle d-none d-lg-inline"></i>

                      <span class="d-lg-none" id="help-offscreen">
                        <i aria-hidden="true" class="pbi-icon-mini pbi-help-circle"></i>&nbsp;Support
                      </span>
                    </button>

                    <app-help-menu class="dropdown-menu" aria-labelledby="help" role="menu"></app-help-menu>
                  </li>

                  <!-- settings menu -->
                  <li class="nav-item dropdown">
                    <button
                      aria-expanded="false"
                      aria-haspopup="true"
                      aria-labelledby="settings-offscreen"
                      class="btn btn-icon-only dropdown-toggle text-white"
                      data-bs-toggle="dropdown"
                      id="settingsDropDown"
                    >
                      <i aria-hidden="true" class="pbi-icon-outline pbi-settings d-none d-lg-inline" id="settings"></i>

                      <span class="d-lg-none" id="settings-offscreen">
                        <i aria-hidden="true" class="pbi-icon-mini pbi-settings"></i>&nbsp;Settings
                      </span>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="settingsDropDown" role="menu">
                      <a class="dropdown-item" routerLink="/autodownload" id="automatic-downloads"
                        >Automatic Downloads</a
                      >
                      <a
                        *appHasPermission="'changePassword'"
                        [attr.href]="
                          (isMasterCardUser$ | async) && isNewOktaURLEnabled
                            ? changePasswordUrl
                            : '/user/change-password'
                        "
                        class="dropdown-item"
                        id="change-password"
                        >Change Password</a
                      >
                      <a class="dropdown-item" routerLink="/user/email-notification" id="email-notification"
                        >Email Notification</a
                      >
                      <div class="divider" role="separator"></div>
                    </div>
                  </li>

                  <!-- User menu -->
                  <li *appHasPermission="'userAccessManagement'" class="nav-item dropdown">
                    <div
                      png-user-account
                      [user]="givenName$ | async"
                      [displaySignIn]="false"
                      [displaySignOut]="true"
                      [displayCopyright]="!(isMasterCardUser$ | async)"
                      [bodyItems]="bodyItems"
                      [copyrightItems]="copyrightItems"
                      [startYear]="2020"
                      (signOut)="logout()"
                    ></div>
                  </li>
                  <li *appHasPermission="'!userAccessManagement'" class="nav-item dropdown">
                    <div
                      png-user-account
                      [user]="givenName$ | async"
                      [displaySignIn]="false"
                      [displaySignOut]="true"
                      [displayCopyright]="!(isMasterCardUser$ | async)"
                      [copyrightItems]="copyrightItems"
                      [startYear]="2020"
                      (signOut)="logout()"
                    ></div>
                  </li>
                  <li *appIfFeature="'start_free_trial_link'">
                    <button
                      pButton
                      type="button"
                      class="btn btn-link btn-help"
                      label="Start Free Trial"
                      (click)="onClick()"
                    ></button>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>
